import { render } from "./ModalIncidence_reports.vue?vue&type=template&id=0e020d1b"
import script from "./ModalIncidence_reports.vue?vue&type=script&lang=js"
export * from "./ModalIncidence_reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__